import(/* webpackMode: "eager" */ "/opt/build/repo/app/cookies/index.tsx")